export const environment = {
  /*... Variables for Session Timeout ...*/

  popUpDuration: 300, /**Duration for which the popup should be shown in seconds - 5 minutes**/
  maxInactiveIntervalTime: 1000 * 600, /**milliseconds - 10 minutes max inactivity*/
  isLoggedIn: true, /**indicates a logged in session is on**/
  timeOutHandler: 0, /**The setTimeout function handler**/
  countdownHandler: 0, /**The handler for showing the timeout countdown**/
  showTimeoutWarning: false,
  /**app.component.ts looks for this every second. If set, the timeout warning is shown with countdown from popupDuration
   * value down to 0**/
  lastApiHitTimestamp: 0,
  /** The timestamp at which the last API hit was made. This does not include keepAlive requests to keep AHCT Session active**/
  lastKeepAliveTimestamp: 0,  /** The timestamp at which the last keep alive was sent **/
  keepAliveWindowMs: 120000,  /** Every 120 seconds, if inactivity has not happened, do a keep alive request to /AHCT/pingSession **/

  isApiHit: false,
  // Angular's production MODE, not the prod environment - matches environment.ts.
  production: true,
  showTestData: true,
  sessionTimeOutInterval: 0,
  IsPopupShowed: false,
  pageLoadTimestamp: 0,
  alerts: [],
  infoMessages: [],
  warnMessages: [],
  envName: 'dev',
  idleSet: 30,
  idleTimeout: 30,
  addForgerockHeaders: true,
  mockService: false,

  // Relative so the app and API share an origin - nginx proxies these to the
  // API container (deploy/svl-ui.nginx.conf). The TOKEN cookie is host-only.
  baseAuthUrl: '',
  baseApiUrl: '/wp-json/',
  baseJSPMLicenseKeyUrl: '/jspm/index.php',
  baseWebRedirUrl: '',
  logoutUrl: '/logout/',
  // Absolute: a separate service on its own host, not proxied by that vhost.
  kioskbaseApiUrl: 'https://d2-kiosk-wp.supremelifeplatform.com/wp-json/',

  sportsBettingUrl: 'https://sb2integration-altenar2-stage.biahosted.com/api/Integration/justbetdevretail',
  sportsBettingUrlV2: 'https://sb2wsdk-altenar2-stage.biahosted.com/altenarWSDK.js',
  // Altenar WSDK integration names
  altenarIntegrationJM: 'justbetdevretail',
  altenarIntegrationGY: 'ibetdevretail',
  walletCodeJM: '251122',
  walletCodeGY: '928025',

  version: '0.0.0',
  gaKey: 'UA-196038757-1'
};
